export default __webpack_public_path__ + "../staticImages/trust-law.svg";